import { createSlice } from '@reduxjs/toolkit';
import { logger } from 'shared/utils/logger';
import { EngineMeasurementsStateType } from '../types/types';
import {
  getAllEngineMeasurements,
  getEngineMeasurementById,
  createEngineMeasurement,
  updateEngineMeasurement,
  deleteEngineMeasurement,
  getEngineMeasurementsByEngineId,
} from '../actions/actions';

const initialState: EngineMeasurementsStateType = {
  engineMeasurements: [],
  engineMeasurementDetail: {
    isLoading: false,
    data: null,
  },
  isLoading: false,
};

export const engineMeasurementSlice = createSlice({
  name: 'engineMeasurement',
  initialState,
  reducers: {
    dropMeasurementsData: (state: EngineMeasurementsStateType) => {
      state.engineMeasurements = [];
      state.engineMeasurementDetail.data = null;
      state.engineMeasurementDetail.isLoading = false;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    // getAllEngineMeasurements
    builder
      .addCase(getAllEngineMeasurements.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllEngineMeasurements.fulfilled, (state, action) => {
        state.isLoading = false;
        state.engineMeasurements = action.payload;
      })
      .addCase(getAllEngineMeasurements.rejected, (state) => {
        state.isLoading = false;
      });

    // getEngineMeasurementById
    builder
      .addCase(getEngineMeasurementById.pending, (state) => {
        state.engineMeasurementDetail.isLoading = true;
      })
      .addCase(getEngineMeasurementById.fulfilled, (state, action) => {
        state.engineMeasurementDetail.isLoading = false;
        state.engineMeasurementDetail.data = action.payload;
      })
      .addCase(getEngineMeasurementById.rejected, (state) => {
        state.engineMeasurementDetail.isLoading = false;
      });

    // createEngineMeasurement
    builder
      .addCase(createEngineMeasurement.fulfilled, (state, action) => {
        state.engineMeasurements.push(action.payload);
      });

    // updateEngineMeasurement
    builder
      .addCase(updateEngineMeasurement.fulfilled, (state, action) => {
        const index = state.engineMeasurements.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) {
          state.engineMeasurements[index] = action.payload;
        }
        if (state.engineMeasurementDetail.data?.id === action.payload.id) {
          state.engineMeasurementDetail.data = action.payload;
        }
      });

    // deleteEngineMeasurement
    builder
      .addCase(deleteEngineMeasurement.fulfilled, (state, action) => {
        state.engineMeasurements = state.engineMeasurements.filter(
          (item) => item.id !== action.payload,
        );
        if (state.engineMeasurementDetail.data?.id === action.payload) {
          state.engineMeasurementDetail.data = null;
        }
      });

    // getEngineMeasurementsByEngineId
    builder
      .addCase(getEngineMeasurementsByEngineId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEngineMeasurementsByEngineId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.engineMeasurements = action.payload;
      })
      .addCase(getEngineMeasurementsByEngineId.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const engineMeasurementActions = engineMeasurementSlice.actions;
export default engineMeasurementSlice.reducer;
